export const SET_INSIGHTS = 'SET_INSIGHTS';
export const CLEAR_INSIGHTS = 'CLEAR_INSIGHTS';
export const SET_INSIGHTS_LOADING = 'SET_INSIGHTS_LOADING';
export const SET_ASSET_CORRELATION = 'SET_ASSET_CORRELATION';
export const CLEAR_ASSET_CORRELATION = 'CLEAR_ASSET_CORRELATION';
